/** @jsxImportSource @emotion/react */

import { DownOutlined, EditOutlined, ExclamationCircleOutlined, SearchOutlined } from '@ant-design/icons'
import { Card, Col, Form, Select, Input, Row, Typography, Button, Menu, Dropdown, Space, Tabs, Table, Modal, Tag, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Spacer from '../../components/layout/Spacer'
import RackFormModal from '../../components/rack/RackFormModal'
import rackAPI from '../../services/rackAPI'
import warehouseAPI from '../../services/warehouseAPI'
import { utcToLocal } from '../../utils/helper'

function RackPage() {
  const tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (value) => <b>{value}</b>
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Status',
      dataIndex: 'deletedAt',
      key: 'deletedAt',
      render: (val) => val ? <Tag color='red'>Inactive</Tag> : <Tag color='green'>Active</Tag>
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value) => <span>{utcToLocal(value)}</span>
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (value, record) => 
      <Space direction="vertical">
        <Button type='link' size='small' onClick={() => selectData(record)}>Edit</Button>
        <Button type='link' size='small' onClick={() => deleteConfirm(value)}>Delete</Button>
        <Link to={`/warehouse/${routeParams.warehouseId}/rack/${value}/shelf`}>
          <Button type='link' size='small' >Shelf </Button>
        </Link>
      </Space>
    },
  ];

  const [modal, setModal] = useState(false)
  const [loading, setloading] = useState(false)
  const routeParams = useParams()

  const [rack, setRack] = useState({
    data: [],
    selected: null,
  })

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  })

  useEffect(() => {
    fetchData(pagination)
  }, [])

  const selectData = (record) => {
    setRack({ ...rack, selected: record })
    setModal(true)
  }

  const deleteConfirm = (id) => {
    Modal.confirm({
      title: 'Do you Want to delete this item?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone',
      onOk: async () => {
        const res = await rackAPI.remove(id)
        message.success('Delete success')
        fetchData({ current: 1, pageSize: 10 })
      },
    });
  }
  const fetchData = async (pagination, filters) => {
    setloading(true)
    const params = {
      ...filters,
      page: pagination.current,
      limit: pagination.pageSize,
    }

    const res = await warehouseAPI.getRacks(routeParams.warehouseId, params)
    setRack({
      data: res.data.rack.items,
      selected: null,
    })
    setPagination({
      current: pagination.current,
      pageSize: pagination.pageSize,
      total: res.data.rack.meta.totalItems
    })
    setloading(false)
  }

  const submitFilter = (value) => {
    fetchData({ current: 1, pageSize: 10 }, value)
  }

  return (
    <div>
      <Typography.Title level={2}>Rack Management</Typography.Title>
      <Card>
        <Row justify='space-between'>
          <Col md={18}>
            <Form onFinish={submitFilter} layout='inline'>
              <Form.Item
                name="search"
                required
              >
                <Input placeholder='Cari data..' suffix={<SearchOutlined />} addonBefore={
                  <Select defaultValue="name">
                    <Select.Option value="name">Rack Name</Select.Option>
                  </Select>
                } />
              </Form.Item>


              <Button htmlType='submit' type='primary'>Search</Button>
            </Form>
          </Col>

          <Button onClick={() => setModal(true)} type='primary' >Add Rack</Button>
        </Row>

      </Card>
      <Spacer />
      <Card>
        <Table
          columns={tableColumns}
          pagination={pagination}
          onChange={(pagination, filter, sorter) => fetchData(pagination)}
          dataSource={rack.data}
          loading={loading}
          rowKey='id' scroll={{ x: true }}
        />
      </Card>

      <RackFormModal
        visible={modal}
        data={rack.selected}
        onCancel={() => {
          setModal(false)
          setRack({ ...rack, selected: null })
        }}
        onFinish={() => {
          setRack({ ...rack, selected: null })
          setModal(false)
          fetchData(pagination)
        }}
        warehouseId={routeParams.warehouseId}
      />
    </div>
  )
}

export default RackPage
